/**
 * Created by Daniel on 7/15/2020
 * Description:
 *
 * ---------maintenance history-------------
 */

import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { ContextMenuConfig, ContextMenuShowAction } from '../../../../widgets/tam-context-menu/tam-context-menu.model';
import { Subscription } from 'rxjs';
import { TaskMenuConfig } from './task-menu.model';

@Component({
    selector: 'tam-task-menu',
    templateUrl: './task-menu.component.html',
    styleUrls: ['./task-menu.component.scss']
})
export class TaskMenuComponent implements OnInit {
    @Input() config: TaskMenuConfig;

    public showStatusName: string;
    public contextMenuConfig: ContextMenuConfig;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _changeDetectorRef: ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.showStatusName = this.config.menuTextContainer[this.config.selectedItemIndex];
        this._initContextMenu();
        this._changeMenuInfo(this.config);

        this._destroySubscriptions.push(
            this.config.actionSubject$.subscribe(action => this._onSubscribeActions(action))
        );
        this._changeDetectorRef.detectChanges();
    }

    onTaskMenuSelect(event) {
        let changeStatus = true;
        const layoutItems = this.contextMenuConfig.items;

        for (let i = 0; i < layoutItems.length; i++) {
            if (event.payload.id < 2) {
                if (layoutItems[i].checked && layoutItems[i].id === event.payload.id) {
                    changeStatus = false;
                    break;
                }
            }
        }

        if (changeStatus) {
            if (event.payload.id < 2) {
                this.contextMenuConfig.items[0].checked = false;
                this.contextMenuConfig.items[1].checked = false;
                this.contextMenuConfig.items[event.payload.id].checked = true;
                this.showStatusName = this.contextMenuConfig.items[event.payload.id].text;
            }

            this.config.feedbackSubject$.next({
                type: 'CHANGE',
                payload: {
                    status: event.payload
                }
            });
        }
    }

    showContextMenu(e: MouseEvent) {
        this._changeDetectorRef.detectChanges();
        this.contextMenuConfig.show$.next(new ContextMenuShowAction(e, ''));
    }

    private _changeMenuInfo(action?) {
        if (action) {
            this.config = action;
        }

        if (this.config) {
            this.contextMenuConfig.items[0].checked = false;
            this.contextMenuConfig.items[1].checked = false;
            this.contextMenuConfig.items.forEach(item => {
                if (item.id === this.config.selectedItemIndex) {
                    item.checked = true;
                    this.showStatusName = this.contextMenuConfig.items[item.id].text;
                }
            });
        }
        this._changeDetectorRef.detectChanges();
    }

    private _initContextMenu() {
        this.contextMenuConfig = new ContextMenuConfig();
        this.contextMenuConfig.single = true;
        this.contextMenuConfig.showItemIcon = false;
        this.contextMenuConfig.clickOnDiv = true;
        this.contextMenuConfig.eventKey = 'slideSheet';
        this.contextMenuConfig.eventValue = true;

        const menuItems = [];
        for (let i = 0; i < this.config.menuTextContainer.length; i++) {
            menuItems.push({ id: i, text: this.config.menuTextContainer[i], checked: i === this.config.selectedItemIndex });
        }
        this.contextMenuConfig.items = menuItems;
        this.contextMenuConfig.events$.subscribe(event => this.onTaskMenuSelect(event));
    }

    private _onSubscribeActions(action) {
        this._changeMenuInfo(action);
    }
}
